import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post";
import QuemSomos from "../pages/quem-somos/page";
import Servicos from "../pages/servicos/page";
import ServicoAutomovel from "../pages/servicos/automovel/page";
import ServicoVidaEmpresarial from "../pages/servicos/vida-empresarial/page";
import ServicoGestaoContratos from "../pages/servicos/gestao-contratos/page";
import ServicoRecuperacaoSinistros from "../pages/servicos/recuperacao-sinistros/page";
import ServicoConsultoriaTecnica from "../pages/servicos/consultoria-tecnica/page";
import ServicoSuporteAcompanhamento from "../pages/servicos/suporte-acompanhamento/page";
import ServicoIncendioEmpresarial from "../pages/servicos/incendio-empresarial/page";
import EstrategiaPage from "../pages/estrategia/page";
import ComoFunciona from "../pages/como-funciona/page";
import CasosDeSucesso from "../pages/casos-de-sucesso/page";
import DepoimentosPage from "../pages/depoimentos/page";
import ContatoPage from "../pages/contato/page";
import ContatoObrigadoPage from "../pages/contato/obrigado/page";
// import TaxaCorretagemPage from '../pages/taxa-corretagem/page';
import FAQPage from "../pages/faq/page";
import ProfissionalizacaoContratacaoPage from "../pages/profissionalizacao-contratacao-seguros/page";
import PoliticaPrivacidadePage from "../pages/politica-de-privacidade/page";
import SegurosMalContratadosPage from "../pages/seguros-mal-contratados/page";
import RelatorioFinalPage from "../pages/relatorio-final/page";
import AdminGuard from "../pages/admin/components/AdminGuard";
import ReavaliacaoFinanceiraSeguros from "../pages/servicos/reavaliacao-financeira-seguros/page";

const ComunidadePage = lazy(() => import('../pages/comunidade/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminHero = lazy(() => import('../pages/admin/hero/page'));
const AdminNotifications = lazy(() => import('../pages/admin/notifications/page'));
const AdminContadores = lazy(() => import('../pages/admin/contadores/page'));
const AdminLeads = lazy(() => import('../pages/admin/leads/page'));
const AdminRelatorioComercial = lazy(() => import('../pages/admin/relatorio-comercial/page'));
const AdminChatAssistant = lazy(() => import('../pages/admin/chat-assistant/page'));
const AdminChatLive = lazy(() => import('../pages/admin/chat-live/page'));
const AdminCoresSecoes = lazy(() => import('../pages/admin/cores-secoes/page'));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/quem-somos", element: <QuemSomos /> },
  { path: "/estrategia", element: <EstrategiaPage /> },
  { path: "/como-funciona", element: <ComoFunciona /> },
  { path: "/casos-de-sucesso", element: <CasosDeSucesso /> },
  { path: "/depoimentos", element: <DepoimentosPage /> },

  // Serviços
  { path: "/servicos", element: <Servicos /> },
  { path: "/servicos/automovel", element: <ServicoAutomovel /> },
  { path: "/servicos/vida-empresarial", element: <ServicoVidaEmpresarial /> },
  { path: "/servicos/gestao-contratos", element: <ServicoGestaoContratos /> },
  { path: "/servicos/recuperacao-sinistros", element: <ServicoRecuperacaoSinistros /> },
  { path: "/servicos/consultoria-tecnica", element: <ServicoConsultoriaTecnica /> },
  { path: "/servicos/suporte-acompanhamento", element: <ServicoSuporteAcompanhamento /> },
  { path: "/servicos/incendio-empresarial", element: <ServicoIncendioEmpresarial /> },
  { path: "/servicos/reavaliacao-financeira-seguros", element: <ReavaliacaoFinanceiraSeguros /> },

  // Conteúdo
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogPostPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/comunidade", element: <ComunidadePage /> },
  // { path: "/taxa-corretagem", element: <TaxaCorretagemPage /> },

  // Institucional / Estratégico
  { path: "/profissionalizacao-contratacao-seguros", element: <ProfissionalizacaoContratacaoPage /> },
  { path: "/seguros-mal-contratados", element: <SegurosMalContratadosPage /> },
  { path: "/relatorio-final", element: <RelatorioFinalPage /> },
  { path: "/politica-de-privacidade", element: <PoliticaPrivacidadePage /> },

  // Contato
  { path: "/contato", element: <ContatoPage /> },
  { path: "/contato/obrigado", element: <ContatoObrigadoPage /> },

  // Admin
  { path: '/admin', element: <AdminGuard><AdminDashboard /></AdminGuard> },
  { path: '/admin/dashboard', element: <AdminGuard><AdminDashboard /></AdminGuard> },
  { path: '/admin/hero', element: <AdminGuard><AdminHero /></AdminGuard> },
  { path: '/admin/notifications', element: <AdminGuard><AdminNotifications /></AdminGuard> },
  { path: '/admin/contadores', element: <AdminGuard><AdminContadores /></AdminGuard> },
  { path: '/admin/leads', element: <AdminGuard><AdminLeads /></AdminGuard> },
  { path: '/admin/relatorio-comercial', element: <AdminGuard><AdminRelatorioComercial /></AdminGuard> },
  { path: '/admin/chat-assistant', element: <AdminGuard><AdminChatAssistant /></AdminGuard> },
  { path: '/admin/chat-live', element: <AdminGuard><AdminChatLive /></AdminGuard> },
  { path: '/admin/cores-secoes', element: <AdminGuard><AdminCoresSecoes /></AdminGuard> },

  // 🔴 SEMPRE POR ÚLTIMO
  { path: "*", element: <NotFound /> },
];

export default routes;